import {TRACK_GA_EVENT, TRACK_GA_PAGEVIEW} from '../actionTypes';

export const GA_CATEGORIES = {
    STORE: 'Store',
    JOIN: 'Join',
    MESSAGES: 'Messages'
};

export const GA_ACTIONS = {
    CATEGORY_CLICKED: 'Category Clicked',
    ORDER_SUBMITTED: 'Order Submitted',
    ERROR_FETCHING: 'Error Fetching',
    MESSAGE: 'Message Shown',
    ADDRESS_VALIDATION_ERROR: 'Address Validation Error'
    // ITEM_ADD_CLICKED: 'Item Add - Clicked',
    // ITEM_QUANTITY_INCREASED: 'Item Quantity - Increased',
    // ITEM_QUANTITY_DECREASED: 'Item Quantity - Decreased',
    // ITEM_REMOVED: 'Item Removed',
    // CHECKOUT_BUTTON_CLICKED: 'Checkout Button Clicked',
};

// const GA_LABELS = {
//     ITEM: 'Item',
//     CART: 'Cart',
//     DETAILS: 'Details',
//     NEW: 'New',
//     UPDATE: 'Update',
//     ADDITIONAL: 'Additional'
// };

export function trackCategoryChange(name){
    return trackGAEvent(GA_CATEGORIES.STORE, GA_ACTIONS.CATEGORY_CLICKED, name);
}

export function trackStoreCheckout(method){
    return function (dispatch){
        dispatch(trackGAEvent(GA_CATEGORIES.STORE, GA_ACTIONS.ORDER_SUBMITTED, method));
        dispatch(trackGAPageView(window.location.pathname + "/submit"));
    }
}

export function trackGAEvent(category, action, label, value){
    return {
        type: TRACK_GA_EVENT,
        category: category,
        action: action,
        label: label,
        value: value
    }
}

export function trackGAPageView(pageUrl){
    return {
        type: TRACK_GA_PAGEVIEW,
        pageUrl: pageUrl
    }
}


// WEBPACK FOOTER //
// ./src/actions/common/gaActions.js